import script from "./LoaderBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoaderBar.vue?vue&type=script&setup=true&lang=ts"

import "./LoaderBar.vue?vue&type=style&index=0&id=77cba7ea&lang=css"

const __exports__ = script;

export default __exports__